<template>
  <div
    id="navMenubd-example"
    class="navbar-menu"
    :class="{'is-active': isActive}"
  >
    <div class="navbar-end">
      <menu-tab
        v-for="tab in menu"
        :key="tab.id"
        :title="tab.title"
        :link="tab.link"
        :dropdown="tab.dropdown"
        @hideMenuInMobile="hideMenuInMobile"
      />
    </div>
  </div>
</template>

<script>
  import MenuTab from '../MenuTab.vue'
  export default {
    name: 'Navigation',
    components: {
      MenuTab
    },
    props: ['isActive'],
    data () {
      return {
        menu: [
          {
            title: 'Home',
            link: '/',
            dropdown: ''
          },
          {
            title: 'Calendar',
            link: '/calendar',
            dropdown: ''
          },
          {
            title: 'News',
            link: '/allnews',
            dropdown: ''
          },
          {
            title: 'Find location',
            link: '/location',
            dropdown: ''
          },
          {
            title: 'Rules',
            link: '/rules',
            dropdown: ''
          },
          {
            title: 'AHL Jobs',
            link: '/jobs',
            dropdown: ''
          },
          {
            title: 'AHL Services',
            link: '/services/join',
            dropdown: [
              {
                id: 'join',
                title: 'Hire AHL Poker',
                link: '/services/join'
              },
              {
                id: 'fee',
                title: '$200 Finders Fee',
                link: '/services/fee'
              },
              {
                id: 'events',
                title: 'Corporate events',
                link: '/services/events'
              }
            ]
          },
          {
            title: 'About Us',
            link: '/about_us',
            dropdown: ''
          },
          {
            title: 'Contact',
            link: '/contact',
            dropdown: ''
          }
        ]
      }
    },
    methods: {
      hideMenuInMobile () {
        this.$emit('hideMenuInMobile')
      }
    }
  }
</script>
